import './styles.scss';

import { ComponentProps } from 'react';
import { getClasses } from '@/utils';

export type BubbleTitleProps = ComponentProps<'div'> & {
  subtitle?: string;
  children: React.ReactNode;
};

const BubbleTitle = ({ className, subtitle, children }: BubbleTitleProps): JSX.Element => (
  <div className={getClasses('BubbleTitle', className)}>
    <div className="BubbleTitle-Bubble">
      <span className="BubbleTitle-Title">{children}</span>
    </div>
    {subtitle && <span className="BubbleTitle-Subtitle">{subtitle}</span>}
  </div>
);

export default BubbleTitle;
